import {
  Card,
  Group,
  Text,
  TextInput,
  UnstyledButton,
  rem,
} from '@mantine/core';
import { useEmployeeFormContext } from '../EmployeePersonalSection';
import { useState } from 'react';
import { notifications } from '@mantine/notifications';
import {
  IconArrowBigLeftFilled,
  IconArrowBigRightFilled,
  IconSquareRoundedPlusFilled,
  IconTrashFilled,
  IconX,
} from '@tabler/icons-react';
import { isEmptyForm } from '@/utils/functions';
import SectionErrorNotification from '@/components/Section/SectionErrorNotification';

export const FamilyContactCard: React.FC = () => {
  const form = useEmployeeFormContext();

  const [curContactIndex, setCurContactIndex] = useState<number>(0);

  const createEmptyContact = (): void => {
    const newEmptyContact = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      relation: '',
    };

    form.insertListItem('contacts', newEmptyContact);
    setCurContactIndex(form.values.contacts.length);
  };

  const loadPreviousContact = (): void => {
    if (curContactIndex <= 0)
      setCurContactIndex(form.values.contacts.length - 1);
    else setCurContactIndex(curContactIndex - 1);
  };

  const loadNextContact = (): void => {
    if (curContactIndex >= form.values.contacts.length - 1)
      setCurContactIndex(0);
    else setCurContactIndex(curContactIndex + 1);
  };

  const deleteCurrentContact = (): void => {
    if (form.values.contacts.length <= 1) {
      notifications.show({
        message: 'Nepodařilo se odstranit poslední kontakt.',
        color: 'red',
        icon: <IconX style={{ width: rem(20), height: rem(20) }} />,
      });
      return;
    }

    form.removeListItem('contacts', curContactIndex);
    if (curContactIndex === form.values.contacts.length - 1)
      loadPreviousContact();
  };

  if (isEmptyForm(form)) {
    return <SectionErrorNotification />;
  }
  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <Group justify="space-between">
        <Group justify="left">
          <Text fw={700} size="lg">
            Kontakt na rodinu
          </Text>
        </Group>

        <Group>
          <UnstyledButton
            data-testid="previous-contact"
            onClick={loadPreviousContact}
          >
            <IconArrowBigLeftFilled />
          </UnstyledButton>

          <UnstyledButton
            data-testid="delete-contact"
            onClick={deleteCurrentContact}
          >
            <IconTrashFilled />
          </UnstyledButton>

          <UnstyledButton
            data-testid="add-contact"
            onClick={createEmptyContact}
          >
            <IconSquareRoundedPlusFilled />
          </UnstyledButton>

          <UnstyledButton data-testid="next-contact" onClick={loadNextContact}>
            <IconArrowBigRightFilled />
          </UnstyledButton>
        </Group>

        <Group justify="right">
          <Text fw={700} size="lg">
            {curContactIndex + 1}/{form.values.contacts.length}
          </Text>
        </Group>
      </Group>

      <Group justify="space-between" grow align="start">
        <TextInput
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="jméno"
          label="Jméno"
          {...form.getInputProps(`contacts.${curContactIndex}.firstName`)}
        />

        <TextInput
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="příjmení"
          label="Příjmení"
          {...form.getInputProps(`contacts.${curContactIndex}.lastName`)}
        />
      </Group>

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="rodinný vztah"
        label="Rodinný vztah"
        {...form.getInputProps(`contacts.${curContactIndex}.relation`)}
      />

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="note"
        label="Telefon"
        {...form.getInputProps(`contacts.${curContactIndex}.phone`)}
      />

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="email"
        label="E-mail"
        {...form.getInputProps(`contacts.${curContactIndex}.email`)}
      />
    </Card>
  );
};
